import Delimited from './Delimited'

export default Delimited
